import { render, staticRenderFns } from "./AcademyNoticeEdit.vue?vue&type=template&id=9e005ea8&scoped=true&lang=pug&"
import script from "./AcademyNoticeEdit.vue?vue&type=script&lang=ts&"
export * from "./AcademyNoticeEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e005ea8",
  null
  
)

export default component.exports